<script setup>
import { getI18n } from '@/plugins/i18n'

import { useDetectDevice } from '@/composables/device'

import CountrySelect from '@/components/shared/CountrySelect.vue'
import FormSectionTitle from '@/components/shared/FormSectionTitle.vue'
import InputDateSelector from '@/components/shared/InputDateSelector.vue'

const staff = defineModel({ type: Object, required: true })

const i18n = getI18n()
const { isMobile } = useDetectDevice()
</script>

<template>
  <q-input
    v-model="staff.fiscal_code"
    :class="isMobile ? 'col-12' : 'col-4'"
    :label="i18n.t('common.fiscalCode')"
    maxlength="20"
  />
  <input-date-selector
    v-model="staff.birth_date"
    :range="false"
    clearable
    :class="isMobile ? 'col-6' : 'col-4'"
    :label="i18n.t('common.birthDate')"
  />
  <q-input
    v-model="staff.birth_place"
    :class="isMobile ? 'col-6' : 'col-4'"
    :label="i18n.t('common.birthPlace')"
    maxlength="100"
  />
  <form-section-title :label="i18n.t('common.residence')" />
  <country-select v-model="staff.country" :class="isMobile ? 'col-12' : 'col-4'" />
  <q-input v-model="staff.city" :class="isMobile ? 'col-8' : 'col-5'" :label="i18n.t('common.city')" />
  <q-input v-model="staff.zip_code" :class="isMobile ? 'col-4' : 'col-3'" :label="i18n.t('common.zipCode')" />
  <q-input v-model="staff.street" :class="isMobile ? 'col-8' : 'col-9'" :label="i18n.t('common.street')" />
  <q-input v-model="staff.street_number" :class="isMobile ? 'col-4' : 'col-3'" :label="i18n.t('common.streetNumber')" />
</template>
